export default {
  name: 'tw-process-state',
  props: {
    success: Boolean,
    error: Boolean,
  },
}
